module.exports = __webpack_public_path__ + "img/yibaoming.347d87b9.png";